"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleScroll = handleScroll;
exports.SCROLL_EVENT_NAME = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

function handleScroll(_ref) {
  var srcElement = _ref.srcElement;
  var _srcElement$documentE = srcElement.documentElement,
      scrollTop = _srcElement$documentE.scrollTop,
      scrollHeight = _srcElement$documentE.scrollHeight;
  var progress = scrollTop / (scrollHeight - window.innerHeight) * 100;
  var roundedProgress = Math.round(progress);

  if ([25, 50, 75, 100].includes(roundedProgress)) {
    _reactGa["default"].event({
      category: 'Page Scroll',
      action: 'Scroll',
      label: window.location.pathname,
      value: "".concat(roundedProgress, "%")
    });
  }
}

var SCROLL_EVENT_NAME = 'scroll';
exports.SCROLL_EVENT_NAME = SCROLL_EVENT_NAME;